import * as t from "react";
import { forwardRef as L } from "react";
const m = L(function(r, e) {
  return /* @__PURE__ */ t.createElement(
    "svg",
    {
      fill: "none",
      ref: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...r
    },
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M13.6504 10.5322L13.7637 10.874H19.4287L15.1484 13.9062L14.8457 14.1201L14.9629 14.4717L16.6045 19.3975L12.2891 16.3408L12 16.1357L11.7109 16.3408L7.39453 19.3975L9.03711 14.4717L9.1543 14.1191L8.85156 13.9053L4.57129 10.875H10.2363L10.3496 10.5332L12 5.58105L13.6504 10.5322Z",
        stroke: "currentColor"
      }
    )
  );
});
export {
  m as StarEmpty
};
